// Use import.meta.glob with eager option to synchronously import all JSON files
// in the current directory. This method returns an object where keys are
// file paths and values are modules.
const files = import.meta.glob('./*.json', { eager: true });
// Initialize an empty object to store the locales.
const locales = {};

// Iterate over the imported files object.
for (const path in files) {
  try {
    // Extract the locale identifier from the file path.
    // This regex removes the leading './' and the '.json' file extension,
    // leaving just the locale identifier (e.g., 'en', 'fr').
    const locale_id = path.replace(/(\.\/|\.json)/g, '');

    // Assign the imported module's default export (which contains the locale
    // data) to the corresponding key in the locales object.
    locales[locale_id] = files[path].default;
  } catch (error) {
    // Log the error. In a production environment, it may be
    // handled more gracefully, perhaps by showing a user-friendly
    // message, sending the error to a monitoring service, etc.
    console.error(`Error loading locale file '${path}':`, error);
  }
}

// Export the locales object for use in other parts of the application.
export default locales;

/*
  Limitations of this approach:
  1. Synchronous Loading: All locale files are loaded synchronously and
     upfront using glob with eager option. This could lead to performance issues
     if there are many or large locale files, as they will all be included
     in the initial bundle.
  2. Lack of Dynamic Import: This method doesn't support dynamically
     importing locale files on-demand. All locale files are loaded at
     the start, regardless of whether they're used.
  3. Error Handling: There's no error handling if a file fails to load
     or if the file structure doesn't match the expected format.
*/
